import { Modal } from "../../shared/ui";
import { createPressHandlers } from "../../shared/utils/pressHandlers";
import css from "./ControlPanel.module.scss";

interface FreebetWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  freebets: Array<{ amount: number }> | null;
  freebetProgress: {
    trackedAmount: number;
    currentProgress: number;
    requiredForFreebet: number;
  } | null;
}

const bgBlueUrl = "/asset_base/bg-blue.png";
const warningUrl = "/asset_base/warning.png";

export const FreebetWarningModal = ({
  isOpen,
  onClose,
  onConfirm,
  freebets,
  freebetProgress,
}: FreebetWarningModalProps) => {
  const hasFreebets = freebets && freebets.length > 0;

  const amount = hasFreebets
    ? freebets[0]?.amount.toFixed(2)
    : freebetProgress?.trackedAmount.toFixed(2);

  return (
    <Modal
      isOpen={isOpen}
      align="center"
      onClose={onClose}
      className={css.freebetWarningModal}
    >
      <div className={css.freebetWarningWrapper}>
        {/* Card */}
        <div className={css.freebetWarningCard}>
          {/* Blue header with bg image */}
          <div
            className={css.freebetWarningHeader}
            style={{ backgroundImage: `url(${bgBlueUrl})` }}
          >
            <img
              src={warningUrl}
              alt="warning"
              className={css.freebetWarningIcon}
            />
            <span className={css.freebetWarningTitle}>ATTENTION!</span>
          </div>

          {/* Body text */}
          <div className={css.freebetWarningBody}>
            {hasFreebets ? (
              <p className={css.freebetWarningText}>
                You have an accumulation on the current bet
                <br />
                of <span className={css.freebetWarningBold}>$ {amount}</span>
                <br />
                If you change the bet amount, the
                <br />
                accumulation will be lost!
              </p>
            ) : (
              <p className={css.freebetWarningText}>
                You have an accumulation on the current bet
                <br />
                of <span className={css.freebetWarningBold}>$ {amount}</span>
                <br />
                If you change the bet amount, the
                <br />
                accumulation will be lost!
              </p>
            )}
          </div>
        </div>

        {/* Buttons */}
        <div className={css.freebetWarningButtons}>
          <button
            className={css.freebetWarningConfirmBtn}
            {...createPressHandlers(onConfirm)}
          >
            CONTINUE
          </button>
          <button
            className={css.freebetWarningCancelBtn}
            {...createPressHandlers(onClose)}
          >
            CANCEL
          </button>
        </div>
      </div>
    </Modal>
  );
};
